// extracted by mini-css-extract-plugin
export default {"wrap":"iframe_wrap__Uy8lS"};